import { SurveyStatus } from '@ps/survey-kernel';
import { Survey, SurveyStatusCount } from '@ps/survey-utils';

import { SurveyStateFilters } from '../survey-state.model';

/** Applies a status change and drops rows that no longer match the active tab. */
export function applySurveyStatusUpdateToList(
  surveys: Survey[],
  surveyId: number,
  status: SurveyStatus,
  statusFilter: SurveyStateFilters['status'],
): Survey[] {
  const updated = surveys.map((survey) =>
    survey.id === surveyId ? { ...survey, status } : survey,
  );

  if (statusFilter === 'all') {
    return updated;
  }

  return updated.filter((survey) => statusFilter === survey.status);
}

/** Shifts tab counters when a survey moves from one status to another. */
export function adjustStatusCounts(
  counts: SurveyStatusCount,
  previousStatus: SurveyStatus | undefined,
  newStatus: SurveyStatus,
): SurveyStatusCount {
  if (previousStatus === undefined || previousStatus === newStatus) {
    return counts;
  }

  const next: SurveyStatusCount = { ...counts };

  if (next[previousStatus] !== undefined) {
    next[previousStatus] = Math.max(0, next[previousStatus] - 1);
  }

  next[newStatus] = (next[newStatus] ?? 0) + 1;

  return next;
}
